import { ServiceFactory } from "../../services";

export default {
  state: {
    summaryStats: {}
  },
  getters: {
    summaryStats: state => {
      return state.summaryStats;
    },
    adsType: state => {
      return state.summaryStats.adsType || {};
    }
  },
  mutations: {
    FillSummaryStats(state, summaryStats) {
      state.summaryStats = summaryStats;
    }
  },
  actions: {
    GetSummaryStats: async function(
      { commit },
      {
        subscriberId,
        businessUnitId,
        toDate,
        fromDate,
        context,
        customerId,
        bookCode,
        commercialName
      }
    ) {
      let PortalStatsService = ServiceFactory.createInstance({
        type: "PortalStatsService",
        data: context
      });

      const summaryStats = await PortalStatsService.GetSummaryStats({
        subscriberId,
        businessUnitId,
        toDate,
        fromDate,
        customerId,
        bookCode,
        commercialName
      });

      commit("FillSummaryStats", summaryStats);
    }
  }
};
